import React, { useEffect, useRef, useState } from 'react';
import { apiFetch } from '../../api/client';

interface JobPreview {
   job_id: string;
   num_queries: number;
   status: string;
   job_name: string;
   done: boolean;
}

const POLL_INTERVAL_MS = 5000;

const Jobs = (): React.JSX.Element => {
   const [jobs, setJobs] = useState<Array<JobPreview>>([]);
   const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

   const fetchJobs = (): void => {
      apiFetch<Array<JobPreview>>('/api/my-jobs', { credentials: 'include' })
         .then((data) => {
            if (!Array.isArray(data)) {
               setJobs([]);
               return;
            }
            setJobs(data);
         })
         .catch(() => setJobs([]));
   };

   useEffect(() => {
      fetchJobs();
      intervalRef.current = setInterval(fetchJobs, POLL_INTERVAL_MS);
      return (): void => {
         if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
         }
      };
   }, []);

   return (
      <article className="md-content__inner md-typeset">
         <h1 id="installation">Recent Jobs</h1>
         Jobs recently executed from this browser.
         <br />
         <table id="my-jobs">
            <thead>
               <tr>
                  <th>Job ID</th>
                  <th>Queries</th>
                  <th>Status</th>
                  <th>Job Name</th>
               </tr>
            </thead>
            <tbody>
               {jobs
                  ? jobs.map((job) => (
                       <tr key={job.job_id}>
                          <td>
                             <a href={`/job/${job.job_id}`}>{job.job_id}</a>
                          </td>
                          <td>{job.num_queries}</td>
                          <td>
                             <span id="job-status" className={`status ${job.status}`}>
                                {job.status}
                             </span>
                          </td>
                          <td>{job.job_name}</td>
                       </tr>
                    ))
                  : null}
            </tbody>
         </table>
      </article>
   );
};

export default Jobs;
